import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['phoneRadio', 'handleRadio', 'phoneField', 'handleField']

  connect () {
    // Set initial state based on which radio is checked
    if (this.handleRadioTarget.checked) {
      this.showHandleField()
    } else {
      this.showPhoneField()
    }
  }

  toggle (event) {
    if (event.target.value === 'phone') {
      this.showPhoneField()
    } else {
      this.showHandleField()
    }
  }

  showPhoneField () {
    this.phoneFieldTarget.classList.remove('hidden')
    this.handleFieldTarget.classList.add('hidden')

    // Enable phone field, disable handle field
    const phoneInput = this.phoneFieldTarget.querySelector('input')
    const handleInput = this.handleFieldTarget.querySelector('input')

    phoneInput.disabled = false
    phoneInput.required = true
    handleInput.disabled = true
    handleInput.required = false
  }

  showHandleField () {
    this.phoneFieldTarget.classList.add('hidden')
    this.handleFieldTarget.classList.remove('hidden')

    // Enable handle field, disable phone field
    const phoneInput = this.phoneFieldTarget.querySelector('input')
    const handleInput = this.handleFieldTarget.querySelector('input')

    phoneInput.disabled = true
    phoneInput.required = false
    handleInput.disabled = false
    handleInput.required = true
  }
}
